import { BaseHTML } from "./BaseHTML"
import { Button } from "@components/controls/Button"
import { TilesState } from "../TilesState"
import { useAppData } from "eddev/hooks"
import { getDefaultAwardStatusText } from "@features/awards/utils/awards-utils"
import { IconCaretRight } from "@components/svg/Icons"

export const Finalists = () => {
  const latestAward = useAppData((data) => data.latestAward)

  console.log({ latestAward })

  return (
    <BaseHTML title={`AGDA Awards ${latestAward?.info?.awardYear}`}>
      <div className="w-full h-full flex justify-between flex-col">
        <p className="type-title-l-medium">
          <div className="text-black">{latestAward?.statusText || getDefaultAwardStatusText(latestAward?.info?.status!)}</div>
          <div className="text-grey">{latestAward?.subtitle}</div>
        </p>
        <Button
          onClick={(e) => {
            TilesState.router?.handleClickEvent(e, "/awards")
          }}
          className="w-fit pointer-events-auto"
          rightIcon={<IconCaretRight />}
        >
          Read More
        </Button>
      </div>
    </BaseHTML>
  )
}

Finalists.widgetConfig = {
  id: "finalists",
  width: 287,
  height: 198,
  isHTML: true,
  alwaysOnTop: true,
  persist: true,
}
